import { NavLink } from "react-router-dom";
import { MapPinned } from "lucide-react";

import { useConfig } from "../../context/configContext";

const MapViewButton = ({ collapsed, onClick }) => {
  const { resetConfig } = useConfig();

  return (
    <NavLink
      to="/maps"
      title={collapsed ? "Map View" : undefined}
      onClick={() => {
        resetConfig();
        onClick?.();
      }}
      className={({ isActive }) =>
        `nav-link ${collapsed ? "is-collapsed" : ""} ${
          isActive ? "is-active" : ""
        }`
      }
    >
      <span className="nav-icon">
        <MapPinned size={19} />
      </span>
      {!collapsed && <span className="nav-label">Map View</span>}
    </NavLink>
  );
};

export default MapViewButton;
